import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';

Swiper.use([Autoplay, EffectFade]);

const slider01El = document.querySelector('#js-slider01');

if (slider01El) {
  const slider01Options = {
    breakpoints: {
      768: {
        spaceBetween: 20,
      },
    },
    loop: true,
    speed: 5000,
    spaceBetween: 10,
    slidesPerView: 'auto',
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
  };

  new Swiper(slider01El, slider01Options);
}

const fvSliderEl = document.querySelector('.js-fv-slider');
if (fvSliderEl) {
  new Swiper(fvSliderEl, {
    modules: [EffectFade, Autoplay],
    loop: true,
    effect: 'fade',
    speed: 1000,
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  });
}

const footerVisualEl = document.querySelector('.js-footer-visual');
const isSpViewport = () => window.matchMedia('(max-width: 767px)').matches;
let footerVisualSwiper = null;

const initFooterVisualSlider = () => {
  if (!footerVisualEl) {
    return;
  }

  if (isSpViewport()) {
    if (!footerVisualSwiper) {
      footerVisualSwiper = new Swiper(footerVisualEl, {
        modules: [Autoplay],
        slidesPerView: 1.2,
        spaceBetween: 5,
        loop: true,
        speed: 7500,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
      });
    }
  } else if (footerVisualSwiper) {
    footerVisualSwiper.destroy(true, true);
    footerVisualSwiper = null;
  }
};

initFooterVisualSlider();
window.addEventListener('resize', initFooterVisualSlider);
